module.exports = __webpack_public_path__ + "static/media/17_7.e185467e.png";